import * as type from "../../types/API/bomApprovalType";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: [],
  total: 0,
  loading: false,
  error: null,
};

const approvalByIdInitialState = {
  data: null,
  loading: false,
  error: null,
};

const acceptRejectInitialState = {
  message: "",
  loading: false,
  error: null,
};

const permissionInitialState = {
  data: [],
  loading: false,
  error: null,
  message: "",
};

export const getBOMApprovalsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BOM_APPROVALS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.GET_BOM_APPROVALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action?.payload?.responseData?.data || [],
        total: action?.payload?.responseData?.total || 0,
      };
    case type.GET_BOM_APPROVALS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getBOMApprovalByIdReducer = (state = approvalByIdInitialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BOM_APPROVAL_BY_ID:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.GET_BOM_APPROVAL_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action?.payload?.responseData?.data || null,
      };
    case type.GET_BOM_APPROVAL_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const acceptRejectBOMApprovalReducer = (state = acceptRejectInitialState, action: IAction) => {
  switch (action.type) {
    case type.ACCEPT_REJECT_BOM_APPROVAL:
      return {
        ...state,
        loading: true,
        error: null,
        message: "",
      };
    case type.ACCEPT_REJECT_BOM_APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action?.payload?.responseData?.message ?? "BOM status updated successfully.",
      };
    case type.ACCEPT_REJECT_BOM_APPROVAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        message: "",
      };
    default:
      return state;
  }
};

export const getBOMApprovalPermissionReducer = (state = permissionInitialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BOM_APPROVAL_PERMISSION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.GET_BOM_APPROVAL_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action?.payload?.responseData?.data || [],
      };
    case type.GET_BOM_APPROVAL_PERMISSION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const setBOMApprovalPermissionReducer = (state = permissionInitialState, action: IAction) => {
  switch (action.type) {
    case type.SET_BOM_APPROVAL_PERMISSION:
      return {
        ...state,
        loading: true,
        error: null,
        message: "",
      };
    case type.SET_BOM_APPROVAL_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action?.payload?.responseData?.message ?? "Permission updated.",
      };
    case type.SET_BOM_APPROVAL_PERMISSION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        message: "",
      };
    default:
      return state;
  }
};

export const deleteBOMApprovalPermissionReducer = (state = permissionInitialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_BOM_APPROVAL_PERMISSION:
      return {
        ...state,
        loading: true,
        error: null,
        message: "",
      };
    case type.DELETE_BOM_APPROVAL_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action?.payload?.responseData?.message ?? "Permission deleted.",
      };
    case type.DELETE_BOM_APPROVAL_PERMISSION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        message: "",
      };
    default:
      return state;
  }
};
